import { render, staticRenderFns } from "./special-tax-notice.vue?vue&type=template&id=4f4caefe&scoped=true"
import script from "./special-tax-notice.vue?vue&type=script&lang=js"
export * from "./special-tax-notice.vue?vue&type=script&lang=js"
import style0 from "./special-tax-notice.vue?vue&type=style&index=0&id=4f4caefe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4caefe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VAppBar,VBtn,VContainer,VDivider,VFooter,VIcon,VMain})
